import { render, staticRenderFns } from "./CoatingSelect.vue?vue&type=template&id=550bdfd3&scoped=true&"
import script from "./CoatingSelect.vue?vue&type=script&lang=js&"
export * from "./CoatingSelect.vue?vue&type=script&lang=js&"
import style0 from "./CoatingSelect.vue?vue&type=style&index=0&id=550bdfd3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550bdfd3",
  null
  
)

export default component.exports